// @ts-check

import React from "react";

import { Button, InlineStack } from "@shopify/polaris";
import { RefreshIcon } from "@shopify/polaris-icons";

import { OrdersDatePicker } from "components/OrdersDatePicker/OrdersDatePicker";

import { useGlobalContext } from "context/GlobalContext";

export const FetchOrdersControls = ({ onRefresh, loading }) => {
  const { isFetchingOrders, refetchOrders, refetchMetrics } = useGlobalContext();

  const handleRefreshClick = () => {
    refetchOrders();
    refetchMetrics();
    onRefresh?.();
  };

  return (
    <InlineStack gap="200">
      <OrdersDatePicker />

      <Button
        icon={RefreshIcon}
        loading={isFetchingOrders || loading}
        onClick={handleRefreshClick}
      >
        Refresh
      </Button>
    </InlineStack>
  );
};
